// utils
// import { suggestedNetwork } from '../../components/carousel/network/NetworkCarousel.mocks';
import Head from 'next/head';
import { useState } from 'react';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import { formatSelects } from '../../utils/FunctionsGlobals';
// import NetworkPieces from '../../components/pieces/network/NetworkPieces';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import { terms_default } from '../../configs/constants';
import styles from './Terms.module.css';

const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });

const Terms = () => {
    const {
        allDataHome,
        isMobile1,
    } = useAuth();
    // useState
    const allCity = allDataHome?.cidades;
    const allCities = allCity ? formatSelects(allCity) : [];
    const site = allDataHome?.site;
    const routes = ['home', 'política'];
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const termos = site?.termos_uso || "";
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;

    return (
        <div className={styles.container}>
            <Head>
                <title>Termos</title>
            </Head>
            <WhatsAppComponent site={site} />
            <PopUpComponent />
            <WelcomePiecesCompany
                site={site}
                titulo={'TERMOS DE USO'}
                routes={routes}
                setActiveDrawer={setActiveDrawer}
                activeDrawer={activeDrawer}
                favorito={[]}
                bannerListagem={urlBannerListagem}
                props={allDataHome}
            />
            <label className={styles.subtitle}>TERMOS</label>
            <p className={styles.adjust_terms}>
                {termos || terms_default(site)}
            </p>
            { site?.rodape == 1 ?
                <AboutPieces1 site={site} allCitiesTipes={allDataHome?.tipos} allCities={allCities} isMobile={isMobile1} allRodape={allDataHome?.rodape}/>
            :
                <AboutPieces site={site} allCitiesTipes={allDataHome?.tipos} allCities={allCities} isMobile={isMobile1}/>
            }

        </div>
    );
};

export default Terms;
